import { CommonModule } from '@angular/common';
import { Component, Input,  OnInit } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { CONSTANTS_DATA } from 'libs/constants/src/lib/constants.data';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'language-name',
  templateUrl: './language-name.component.html',
  standalone: true,
  imports: [CommonModule, TranslateModule]
})
export class LanguageNameComponent implements OnInit {
  @Input() additionData = new BehaviorSubject(null);
  @Input() columnData  = new BehaviorSubject(null);
  type!: any;
  constructor() { }

  ngOnInit(): void {
  }

  getLanguageName(value:any){
    var date =CONSTANTS_DATA.ALL_LANGUAGES.find((lang) => (lang.LANG_CODE === value)) 
    return date?.LANG_CODE;
  }
}